import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as fileSaver from 'file-saver';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import { SolicitudEquipoDocumentosService } from 'src/app/services/solicitud-equipo-documentos/solicitud-equipo-documentos.service';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudVehiculoDocumentosService } from 'src/app/services/solicitud-vehiculo-documentos/solicitud-vehiculo-documentos.service';

@Component({
  selector: 'app-visor-pdf-dialog',
  templateUrl: './visor-pdf-dialog.component.html',
  styleUrls: ['./visor-pdf-dialog.component.css']
})
export class VisorPdfDialogComponent implements OnInit {
  src = ''
  imagesrc = ''
  esPDF: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<VisorPdfDialogComponent>,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
    private solicitudEquipoDocumentoService: SolicitudEquipoDocumentosService,
    private solicitudVehiculoDocumentoService: SolicitudVehiculoDocumentosService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    @Inject(MAT_DIALOG_DATA) public model: VisorPdfDocumentoModel) {
    if (model.nombreArchivo.indexOf('.pdf') > -1) {
      this.esPDF = true;
    }
  }

  ngOnInit() {
    switch (this.model.seccion) {
      case SolicitudSeccion.Personal:
        this.solicitudPersonaDocumentoService.downloadasStringDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          if (this.esPDF)
            this.src = `data:application/pdf;base64,${data.content}`;
          else
            this.imagesrc = `data:image/jpg;base64,${data.content}`;
        });
        break;
      case SolicitudSeccion.Equipos:
        this.solicitudEquipoDocumentoService.downloadasStringDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          if (this.esPDF)
            this.src = `data:application/pdf;base64,${data.content}`;
          else
            this.imagesrc = `data:image/jpg;base64,${data.content}`;
        });
        break;
      case SolicitudSeccion.Vehiculos:
        this.solicitudVehiculoDocumentoService.downloadasStringDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          if (this.esPDF)
            this.src = `data:application/pdf;base64,${data.content}`;
          else
            this.imagesrc = `data:image/jpg;base64,${data.content}`;
        });
        break;
      case SolicitudSeccion.DocumentacionTecnica:
        this.solicitudDocumentoTecnicoService.downloadasStringDocumento(this.model.codigoSolicitud, this.model.idSolicitudDocumento).subscribe(data => {
          if (this.esPDF)
            this.src = `data:application/pdf;base64,${data.content}`;
          else
            this.imagesrc = `data:image/jpg;base64,${data.content}`;
        });
        break;
      default:
        break;
    }
  }

  descargar() {
    switch (this.model.seccion) {
      case SolicitudSeccion.Personal:
        this.solicitudPersonaDocumentoService.downloadDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          fileSaver.saveAs(blob, this.model.nombreArchivo);
        });
        break;
      case SolicitudSeccion.Equipos:
        this.solicitudEquipoDocumentoService.downloadDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          fileSaver.saveAs(blob, this.model.nombreArchivo);
        });
        break;
      case SolicitudSeccion.Vehiculos:
        this.solicitudVehiculoDocumentoService.downloadDocumento(this.model.codigoSolicitud, this.model.idRegistro, this.model.idSolicitudDocumento).subscribe(data => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          fileSaver.saveAs(blob, this.model.nombreArchivo);
        });
        break;
      case SolicitudSeccion.DocumentacionTecnica:
        this.solicitudDocumentoTecnicoService.downloadDocumento(this.model.codigoSolicitud, this.model.idSolicitudDocumento).subscribe(data => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          fileSaver.saveAs(blob, this.model.nombreArchivo);
        });
        break;
      default:
        break;
    }


  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
